import { CHANGE_BG } from './actionTypes.js';

export const changeBackground = background => {
  return {
    type: CHANGE_BG,
    payload: background
  }
}